import React from 'react';
import { motion } from 'framer-motion';
import AudioPlayer from './AudioPlayer';
import SEO from './SEO';
import './PlayerPage.css';

const PlayerPage = ({ 
  currentTrack, 
  isPlaying, 
  tracks = [], 
  onTrackSelect, 
  onPlayPause, 
  onTrackEnd, 
  onNextTrack, 
  onPreviousTrack 
}) => {
  // Плеер всегда отображается, даже если треков нет
  return (
    <>
      <SEO 
        title="Music Player"
        description="Listen to Sergey Levitskiy's music - Commercial and Underground Electronic Music tracks. Professional DJ mixes and original productions."
        keywords="Sergey Levitskiy music, DJ tracks, Electronic Music, Commercial Music, Underground Music, Music Player"
      />
      <div className="player-page">
      {/* Психоделические эффекты фона */}
      <div className="music-waves"></div>
      <div className="music-glow"></div>
      <div className="film-overlay"></div>
      <div className="noise-overlay"></div>
      <div className="geometric-shapes"></div>
      <div className="floating-particles"></div>
      
      <motion.div
        className="player-page-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <AudioPlayer
          track={currentTrack}
          isPlaying={isPlaying}
          onPlayPause={onPlayPause}
          onTrackEnd={onTrackEnd}
          tracks={tracks}
          onTrackSelect={onTrackSelect}
          onNextTrack={onNextTrack}
          onPreviousTrack={onPreviousTrack}
        />
      </motion.div>
    </div>
    </>
  );
};

export default PlayerPage;

